import { Environment, type EnvironmentConfig, type RelayFieldLogger } from 'relay-runtime';

import { getSharedRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
import type { ExternalDependencies } from '@atlassian/relay-fetch/multi-fetch';

type Props = {
	log?: EnvironmentConfig['log'];
	requiredFieldLogger?: RelayFieldLogger;
	networkOptions?: ExternalDependencies;
};

type AtlassianRelayEnvironment = Environment;

export function createRelayEnvironment(environmentOptions: Props): AtlassianRelayEnvironment;

export function createRelayEnvironment(
	environmentOptions: Omit<Props, 'networkOptions'>,
): AtlassianRelayEnvironment;

export function createRelayEnvironment(environmentOptions: Props): AtlassianRelayEnvironment {
	const options = getSharedRelayEnvironmentConfig(environmentOptions);
	return new Environment(options);
}
